import { render } from "./ModalApprovaRifiuta.vue?vue&type=template&id=02ad595a&ts=true"
import script from "./ModalApprovaRifiuta.vue?vue&type=script&lang=ts"
export * from "./ModalApprovaRifiuta.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__